var _defineProperty = require("/private/tmp/ncsacw-website/frontend/node_modules/@babel/runtime/helpers/defineProperty.js");
var behavior = require("../../uswds-core/src/js/utils/behavior");
var _require = require("../../uswds-core/src/js/events"),
  CLICK = _require.CLICK;
var _require2 = require("../../uswds-core/src/js/config"),
  PREFIX = _require2.prefix;
var HEADER = ".".concat(PREFIX, "-banner__header");
var EXPANDED_CLASS = "".concat(PREFIX, "-banner__header--expanded");
var toggleBanner = function toggleEl(event) {
  event.preventDefault();
  this.closest(HEADER).classList.toggle(EXPANDED_CLASS);
};
module.exports = behavior(_defineProperty({}, CLICK, _defineProperty({}, "".concat(HEADER, " [aria-controls]"), toggleBanner)));